module.exports = __webpack_public_path__ + "static/media/116-stop button.e8364e1e.svg";